import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useSnackbar } from "notistack";
import { getElements, updateElement } from "../../database/API";
import theme from "../../theme";
import CustomButtonAdmin from "./CustomButtonAdmin";
import ReactDatePicker from "react-datepicker";
import { diaBlock, setMaxPx } from "../../utils";
import { ca } from "date-fns/locale";
import calStyle from "../../theme/calStyle.css";
import moment from "moment/min/moment-with-locales";

export default function DialogEditData({ setUpdate, open, setOpen, id, label, reserva }) {
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [data, setData] = useState(reserva.data);
    const [dataBlock, setDataBlock] = useState([]);

    useEffect(() => {
        const getActivitats = async () => {
            const block = await getElements("data_block");
            setDataBlock(block?.result);
            setLoading(false);
        };
        open && getActivitats();
    }, [open]);

    function disabledDate(current) {
        return (
            setMaxPx(reserva?.activitat?.max, reserva?.activitat?.reserves, moment(current).format("YYYY-MM-DD")) !== 0 &&
            !diaBlock(dataBlock, moment(current).format("YYYY-MM-DD"), moment(current).weekday() === 5 || moment(current).weekday() === 6)
        );
    }

    const handleClose = () => {
        setOpen(false);
    };

    const editar = async () => {
        setLoading(true);
        await updateElement("reserves", { data: moment(data).format("YYYY-MM-DD") }, id);
        enqueueSnackbar("Actualitzat", {
            variant: "success",
        });
        setUpdate((prev) => prev + 1);
        setOpen(false);
        setLoading(false);
    };

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            PaperProps={{
                style: {
                    borderRadius: 0,
                    width: 400,
                },
            }}
            maxWidth="lg"
        >
            <DialogTitle sx={{ background: theme.color.primary, color: "white" }}>
                <Box display="flex" justifyContent={"space-between"}>
                    Editar {label}
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box my={3}>
                    <ReactDatePicker
                        onChange={(data) => {
                            setData(data);
                        }}
                        selected={data ?? ""}
                        locale={ca}
                        dateFormat="dd/MM/yyyy"
                        // renderDayContents={renderDia}
                        inline
                        minDate={moment().add(2, "days").toDate()}
                        maxDate={moment().add(2, "months").toDate()}
                        // excludeDates={exclude}
                        filterDate={disabledDate}
                        style={calStyle}
                    />
                    <Typography mt={4}>
                        <strong>Nova data</strong>: {moment(data).format("LL")}
                    </Typography>
                    <CustomButtonAdmin title={"Guardar"} fullWidth loading={loading} onClick={editar} />
                </Box>
            </DialogContent>
        </Dialog>
    );
}
